import React from 'react';
import { Button } from '@repo/ui/components/ui/button';
import {
  Dialog,
  DialogTitle,
  DialogHeader,
  DialogContentWithCustomClose,
} from '@repo/ui/components/ui/dialog';
import Image from 'next/image';
import { DOG_IN_FLOWER_POT } from '@web/constants/general';
import Link from 'next/link';
import { ExternalLink } from '@repo/ui/components/ui/icons';
type IBookingProps = {
  showModal: boolean;
  setShowModal: (val: boolean) => void;
  lineUrl: string;
};

export const BookingModal = ({
  showModal,
  setShowModal,
  lineUrl,
}: IBookingProps) => {
  return (
    <Dialog
      open={showModal}
      onOpenChange={(val) => {
        if (!val) {
          setShowModal(false);
        }
      }}
    >
      <DialogContentWithCustomClose className="p-10">
        <div className="flex items-center justify-between">
          <DialogTitle className="text-left text-xl"></DialogTitle>
          <Button
            className="absolute right-10 h-[34px] w-[42px] rounded-[18px]"
            variant="secondary"
            onClick={() => setShowModal(false)}
          >
            <Image
              src="/icons/times.svg"
              width={18}
              height={18}
              className="min-h-[18px] min-w-[18px]"
              alt={'times'}
            />
            <span className="sr-only">Close</span>
          </Button>
        </div>
        <DialogHeader>
          <Image
            className="mx-auto"
            src={DOG_IN_FLOWER_POT}
            width={179}
            height={174}
            alt="service"
          />
          <p className="text-h6 text-center">Booking an service?</p>
          <p className="text-b3 text-center">
            Scan the Qr code to make appointments
          </p>
          <div className="mx-auto !mt-3">
            <Link href={lineUrl} target="_blank">
              <Button className="bg-success-foreground ">
                <ExternalLink size={18} />
                Add line friend
              </Button>
            </Link>
          </div>
        </DialogHeader>
      </DialogContentWithCustomClose>
    </Dialog>
  );
};
